import React from 'react';

import { Inline, Fullscreen, RappiGif } from './styles';

interface Props {
  fullScreen?: boolean;
  className?: string;
}

const Loader = ({ fullScreen, className }: Props) => {
  const Container = fullScreen ? Fullscreen : Inline;

  return (
    <Container className={className || ''} data-testid={`loading-${fullScreen ? 'fullscreen' : 'inline'}`}>
      <RappiGif src="/corporate/images/loading-gif.gif" alt="loading" />
    </Container>
  );
};

export default Loader;
